import {observer} from 'mobx-react-lite';
import React from 'react';
import {useTranslation} from 'react-i18next';

type Props = {
  message: string;
  onRetry?: () => void;
};

const UErrorMessage = ({message, onRetry}: Props): React.ReactElement => {
  const {t} = useTranslation('common');
  return (
    <div data-testid='error-message'>
      {message}
      {onRetry ? <button onClick={onRetry}>{t('actions.retry')}</button> : null}
    </div>
  );
};

export const ErrorMessage = observer(UErrorMessage);
